import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation UnitSectionDelete($uid: String!){
        unit_section_delete (uid: $uid) {
            success
        }
    }
`;

export async function unitSectionDelete(uid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ unit_section_delete: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.unit_section_delete;
}
